import type { HotelSearchResultItem, HotelSearchSavedItemData } from 'tripPlanner/api/types'
import {
  mapDrawerHotelPricingFields,
  mapImages,
  mapPrice,
} from 'tripPlanner/mappers/offerDetailSharedFields'
import type {
  DrawerHotel,
  DrawerHotelGeoLocation,
} from './types'

// Re-exported for existing callers of this path only — new code should import these from
// tripPlanner/mappers/offerDetailSharedFields directly, not add a new import here.
export { mapDrawerHotelPricingFields, mapImages, mapPrice }

export function composeLocationString(
  city?: string,
  country?: string,
): string {
  return [city, country].filter(Boolean).join(', ')
}

export function mapGeoLocation(
  geoLocation?: HotelSearchSavedItemData['location']['geoLocation'],
): DrawerHotelGeoLocation | undefined {
  if (!geoLocation) {
    return undefined
  }

  return {
    lat: geoLocation.lat,
    lng: geoLocation.lng,
  }
}

export function mapToDrawerHotel(item: HotelSearchResultItem): DrawerHotel | undefined {
  const { savedItemData } = item

  if (!savedItemData?.imageIds?.length) {
    return undefined
  }

  const { location } = savedItemData
  const nights = savedItemData.pricing?.durationNights ?? item.numberOfNights

  return {
    id: savedItemData.offerId,
    offerId: savedItemData.offerId,
    offerType: savedItemData.offerType,
    slug: item.slug,
    name: item.name,
    description: item.description || undefined,
    location: composeLocationString(location.city, location.country),
    images: mapImages(savedItemData.imageIds),
    rating: savedItemData.rating,
    ...mapDrawerHotelPricingFields(savedItemData.pricing, nights, savedItemData.currencyCode),
    geoLocation: mapGeoLocation(location.geoLocation),
    deeplinkUrl: item.deeplinkUrl,
    checkIn: savedItemData.checkIn,
    checkOut: savedItemData.checkOut,
  }
}
